export const title = document
  .querySelector("meta[property='og:title']")
  .getAttribute('content');

export const course = document
  .querySelector("meta[name='course']")
  .getAttribute('content');

export const option = document
  .querySelector("meta[name='option']")
  .getAttribute('content');
